<app-main-layout>
  <app-order-view-page></app-order-view-page>
</app-main-layout>
